import { DEFAULT_CONTENT } from '@/data/content';

export const FONT_OPTIONS = [
  { id: 'anton', label: 'Anton (default)', stack: "'Anton', Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif" },
  { id: 'archivo', label: 'Archivo Black', stack: "'Archivo Black', Impact, sans-serif" },
  { id: 'bebas', label: 'Bebas Neue', stack: "'Bebas Neue', 'Arial Narrow', sans-serif" },
  { id: 'oswald', label: 'Oswald', stack: "'Oswald', 'Arial Narrow', sans-serif" },
  { id: 'impact', label: 'Impact (system)', stack: "Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif" },
];

export const DENSITY_OPTIONS = [
  { id: 'compact', label: 'Compact', value: 'clamp(3rem, 7vw, 5rem)' },
  { id: 'regular', label: 'Regular (default)', value: 'clamp(4rem, 10vw, 8rem)' },
  { id: 'generous', label: 'Generous', value: 'clamp(6rem, 13vw, 11rem)' },
];

function hexToRgb(hex) {
  const h = (hex || '').replace('#', '');
  const full = h.length === 3 ? h.split('').map((c) => c + c).join('') : h;
  const n = parseInt(full, 16);
  if (Number.isNaN(n) || full.length !== 6) return [0, 0, 0];
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}

function mix(a, b, t) {
  return a.map((v, i) => Math.round(v + (b[i] - v) * t));
}

const trip = (rgb) => rgb.join(' ');

// Applies the editable theme to CSS custom properties consumed by Tailwind
// (rgb(var(--y-*) / <alpha-value>)) and the brand animations.
export function applyTheme(theme = {}) {
  const t = { ...DEFAULT_CONTENT.theme, ...theme };
  const s = document.documentElement.style;

  const purple = hexToRgb(t.purple);
  const green = hexToRgb(t.green);
  const ground = hexToRgb(t.ground);
  const ink = hexToRgb(t.ink);

  s.setProperty('--y-purple', trip(purple));
  s.setProperty('--y-purple-light', trip(mix(purple, [255, 255, 255], 0.3)));
  s.setProperty('--y-purple-xl', trip(mix(purple, [255, 255, 255], 0.5)));
  s.setProperty('--y-green', trip(green));
  s.setProperty('--y-ground', trip(ground));
  s.setProperty('--y-sand', trip(mix(ground, [0, 0, 0], 0.035)));
  s.setProperty('--y-sand2', trip(mix(ground, [0, 0, 0], 0.055)));
  s.setProperty('--y-ink', trip(ink));

  const font = FONT_OPTIONS.find((f) => f.id === t.displayFont) || FONT_OPTIONS[0];
  s.setProperty('--y-display', font.stack);

  const density = DENSITY_OPTIONS.find((d) => d.id === t.density) || DENSITY_OPTIONS[1];
  s.setProperty('--y-sec-py', density.value);
}
